export default "__VITE_ASSET__D9kvZUr9__"